export const countryJQL = {
    country: [
        'id',
        'name',
        'nationalFlag',
        'banner',
        'countryCode',
        'isActive',
        {
            'products': [
                'id',
            ]
        }
    ],
    conditions: {
        where: {
            country_isActive: {
                equalTo: true
            }
        }
    }
};

export const privateCountryJQL = (userID: any) => {
    return {
        country: [
            'id',
            'name',
            'nationalFlag',
            'banner',
            'countryCode',
            'isActive',
            {
                'products': [
                    'id',
                    { 'user': ['id'] }
                ]
            }
        ],
        conditions: {
            where: {
                country_isActive: {
                    equalTo: true
                },
                products_user: {
                    equalTo: userID
                }
            }
        }
    }
};

export const featuredCountryJQL = {
    country: [
        'id',
        'name',
        'nationalFlag',
        'banner',
        'countryCode',
        'isActive',
    ],
    conditions: {
        where: {
            country_isActive: {
                equalTo: true
            },
            country_isFeatured: {
                equalTo: true
            }
        }
    }
};

export const findTripDetailJQL = (conditions: any) => {
    return {
        product: [
            'id',
            'isOpenTrip',
            'state',
            'title',
            'totalPrice',
            'maxGuest',
            'instantBooking',
            'addSlotPrice',
            'startTripDate',
            'endTripDate',
            'highlight',
            'description',
            'meetingAddress',
            'additionalContact',
            'meetingLat',
            'meetingLng',
            'minGuest',
            'avDays',
            'feeAmount',
            'maxAddSlot',
            'addPriceFeeAmount',
            { country: ['id', 'name', 'nationalFlag', 'countryCode'] },
            {
                productLocation: ['id', 'locationName'],
            },
            {
                productService: ['id', 'price', 'name', 'description', 'code', 'feeAmount'],
            },
            {
                file: ['urls', 'id', 'description'],
            },
            {
                user: ['id'],
            },
        ],
        conditions
    }
}


export const GuideTripList = (page = 1, limit = 7, userId: number, isOpenTrip = true) => {
    return {
        product: [
            'id',
            'isOpenTrip',
            'state',
            'title',
            'totalPrice',
            'maxGuest',
            'instantBooking',
            'addSlotPrice',
            'startTripDate',
            'endTripDate',
            'highlight',
            'description',
            'meetingAddress',
            'minGuest',
            'maxAddSlot',
            { country: ['id', 'name', 'nationalFlag', 'countryCode'] },
            {
                productLocation: ['id', 'locationName'],
            },
            {
                productService: ['id', 'price', 'name', 'description'],
            },
            {
                file: ['urls', 'id'],
            },
            {
                user: ['id'],
            },
        ],
        conditions: {
            where: {
                product_user: {
                    equalTo: userId
                },
                product_isOpenTrip: {
                    equalTo: isOpenTrip
                },
                product_state: {
                    notEqualTo: 'deleted'
                }
            },
            pagination: {
                limit: limit,
                page: page,
            },
        }
    }
}